<div class="street-light-planner-step1">
  <p class="label">
    {{ 'module.energyMap.streetlightPlanner.step1Instructon1Text' | translate }}
  </p>

  <p class="label">
    {{ 'module.energyMap.streetlightPlanner.step1Instruction2Text' | translate }}
  </p>

  <label class="title">{{ 'module.energyMap.streetlightPlanner.step1InstructionHeaderText' | translate }}</label>

  <div class="choices">
    <button class="btn btn-primary -border-inverted btn-yes" [class.-active]="isRecommendation === true" (click)="select(true)">
      {{ 'module.energyMap.streetlightPlanner.step1ButtonRecommendedText' | translate }}
    </button>
    <button class="btn btn-primary -border-inverted btn-no" [class.-active]="isRecommendation === false" (click)="select(false)">
      {{ 'module.energyMap.streetlightPlanner.step1ButtonManualText' | translate }}
    </button>
  </div>
</div>
